import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@commons';
import { GenericResponse } from '@interfaces';
import { Observable } from 'rxjs';
import { ChangePasswordBody } from './change-password.model';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  constructor(private http: HttpClient, private config: ConfigService) { }

  public changePassword(body: ChangePasswordBody): Observable<GenericResponse> {
    return this.http.put<GenericResponse>(this.config.getUrl('user.changePassword'), body);
  }
}
